import classes from './Card.module.css'

const Card = ({children, className, style}) => {
    return(
        <div className={`${classes.container} ${className}`} style={style}>
            {children}
        </div>
    )
}

export default Card